import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackAdobePageView } from '../utils/adobeAnalytics';

/**
 * Fires an Adobe Analytics page_view event on every route change.
 * Must be used inside a component that is a descendant of BrowserRouter.
 * Is a no-op when window.s (OTE AppMeasurement) is not yet available.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    trackAdobePageView(path);
  }, [location]);
}
